import workerChannel from "./worker.channel";
import { put, take } from "typed-redux-saga";
import { workerActions } from "../../reducers/worker.slice";

function* silhouetteScoreWorker() {
  const webWorker = new Worker(
    new URL("../workers/silhouette-score.worker.js", import.meta.url)
  );

  const channel = workerChannel(webWorker);

  while (true) {
    try {
      const action = yield* take(workerActions.silhouetteScore);
      webWorker.postMessage(action.payload);

      const data = (yield* take(channel)) as {
        key: string;
        silhouetteScore: number;
      };

      yield* put(
        workerActions.setSilhouetteScore({
          key: action.payload.key,
          // TODO fallback to 0 otherwise it keeps recalculating when NaN
          silhouetteScore: data.silhouetteScore || 0,
        })
      );
    } catch (e) {
      console.error(e);
    }
  }
}

export default silhouetteScoreWorker;
